import userManagementReducer, { userManagementActions } from './user-management.slice';

export { userManagementActions };

export default userManagementReducer;
